import { AddHTMLSpinnerCancel } from "../utils/AddHTMLSpinnerCancel";
import { DetermineTextColor } from "../utils/DetermineTextColor";
import { enumPanelBorderStyle, kFramelessBorderThickness } from "../constants";
import { QPanel } from "./QPanel";
import { QStaticText } from "./QStaticText";
import { UpdateHTMLSpinnerText } from "../utils/UpdateHTMLSpinnerText";
import { updateWaitingLongTime } from "../utils/updateWaitingLongTime";
import { Globals } from "./Globals";
import { uFramelessPanelColor } from "../whitelabel/brand";
import { CenterIt } from "../utils/CenterIt";

export class QWaitingPanel extends QPanel {
  constructor() {
    super();
    this.fMsgBox = null;
    this.fWSMgr = null;
    this.fParentPanel = null;
    this.fCancelButton = null;
    this.fMsgColor = null;
    this.fMsgSize = null;
    this.fBackgroundPanel = null;
  }

  InitWaitingPanel(message, backGroundPanel, wsMgr, panelWidth) {
    var pW = panelWidth;
    var pH = 200;

    this.fWSMgr = wsMgr;
    this.SizePanel(pW, pH);

    this.fUIColors = wsMgr.GetUIColors();
    var availableWidth = backGroundPanel.fWidth;
    var availableHeight = backGroundPanel.fHeight;
    this.fBackgroundPanel = backGroundPanel;
    var portX = backGroundPanel.fHorzOffset + CenterIt(availableWidth, pW);
    var portY = backGroundPanel.fVertOffset + CenterIt(availableHeight, pH);

    this.PositionPanel(portX, portY);

    this.SetModalOn(true);
    this.SetOutsideClickDismissOn(false);

    this.SetShadowOn(true);
    this.SetBorderThickness(2);
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);

    this.timeoutmsg = setTimeout(function () {
      updateWaitingLongTime(message);
    }, 5000);
    var tMessage = this.AddMessage(message);

    this.SetFillColor(uFramelessPanelColor);
    this.SetBorderStyle(enumPanelBorderStyle.framelessBorder);
    this.SetBorderThickness(kFramelessBorderThickness);
    this.SetShadowOn(false);

    this.fMsgColor = DetermineTextColor(uFramelessPanelColor);
    this.fMsgSize = 20;
    this.fWSMgr.DoAppLoadingAnimation(message);
    //return tMessage;
  }

  AttachProcess(process) {
    this.fProcess = process;
  }

  GetProcess() {
    return this.fProcess;
  }

  UpdateMessageSize(tMessage, messageStr) {
    UpdateHTMLSpinnerText(messageStr);
  }

  SetMsgColor(msgColor) {
    this.fMsgColor = msgColor;
  }

  DoClosePanel() {
    this.fWSMgr.ClearAppLoadingAnimation();
    Globals._timerMgr.ClearTimer();
  }

  AddCancel(parentPanel) {
    this.fParentPanel = parentPanel;
    this.fCancelButton = AddHTMLSpinnerCancel(this, "CancelAction");
  }

  HideCancel() {
    if (this.fCancelButton) this.fCancelButton.style.display = "hidden";
  }

  PositionMsg(msgElement, message) {
    msgElement.SetLabel(message);
    //var yPos = this.GetHeight() - msgElement.GetHeight()  - 15;
    //var tW = msgElement.DoCalculateMinWidth();
    //var xPos = CenterIt(this.GetWidth(), tW);
    //msgElement.PositionElement(xPos, yPos);
    //msgElement.AutoSize();
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var panelHandled = false;
    switch (cmdCode) {
      case "CancelAction":
        var process = this.GetProcess();
        if (process?.SetAbort) {
          process.SetAbort();
        }
        if (this.fParentPanel?.cancelAction) {
          this.fParentPanel.CancelAction();
        } else {
          this.DoExit(false);
        }
        panelHandled = true;
        break;
    }
    return panelHandled;
  }

  AddMessage(message) {
    var msg = new QStaticText();
    msg.InitStaticText();
    if (this.fMsgColor != null) msg.SetTextColor(this.fMsgColor);
    if (this.fMsgSize != null) msg.SetFontSize(this.fMsgSize);
    msg.SetBold(true);
    msg.SetAlignment("left");
    this.PositionMsg(msg, message);
    this.fMsgBox = msg;
    return msg;
  }

  UpdateMessage(message) {
    this.PositionMsg(this.fMsgBox, message);
    this.UpdateMessageSize(this.fMsgBox, message);
    return this.fMsgBox;
  }
}
